import { jsx as _jsx } from "react/jsx-runtime";
const CrossIcon = props => {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M20 20L4 4m16 0L4 20"
    })
  });
};
export default CrossIcon;